
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7903"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7903"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fUvr1", function(module, exports) {

$parcel$export(module.exports, "renderPost", () => $b954784b1e5f57b8$export$823f4865e91cfbff);
$parcel$export(module.exports, "loadMyLikes", () => $b954784b1e5f57b8$export$1976b3a42df716d9);
$parcel$export(module.exports, "isLoggedIn", () => (parcelRequire("5IRmI")).isLoggedIn);
// Shared post-card rendering — used by both the feed page (posts.js) and the
// single-post permalink page (post-view.js), so the two stay in sync.

var $3qsiv = parcelRequire("3qsiv");

var $aSNdN = parcelRequire("aSNdN");

var $5IRmI = parcelRequire("5IRmI");

var $36CJS = parcelRequire("36CJS");
// Marks the cut point an author can insert in the composer for a "Read more"
// break. Plain text (not real HTML) since renderBodyHtml escapes the body
// before looking for it.
const $b954784b1e5f57b8$var$READ_MORE_MARKER = '<!--more-->';
// postIds the signed-in user has liked, loaded once by loadMyLikes()
let $b954784b1e5f57b8$var$myLikedPostIds = new Set();
// ─── Helpers ──────────────────────────────────────────────────────────────────
function $b954784b1e5f57b8$var$isCloudinaryUrl(url) {
    return typeof url === 'string' && url.startsWith('https://res.cloudinary.com/');
}
function $b954784b1e5f57b8$var$isCloudinaryVideo(url) {
    if (!$b954784b1e5f57b8$var$isCloudinaryUrl(url)) return false;
    // Cloudinary video URLs contain /video/upload/ in the path
    return url.includes('/video/upload/');
}
// Detect audio uploads. Cloudinary stores audio uploaded via the `auto`
// resource type under /video/upload/ — so we check the file extension
// *before* checking the path segment to avoid treating audio as video.
function $b954784b1e5f57b8$var$isAudioUrl(url) {
    if (!$b954784b1e5f57b8$var$isCloudinaryUrl(url)) return false;
    const lower = url.toLowerCase();
    if (lower.endsWith('.m4a') || lower.endsWith('.mp3') || lower.endsWith('.wav') || lower.endsWith('.ogg') || lower.endsWith('.aac') || lower.endsWith('.flac')) return true;
    if (url.includes('/raw/upload/')) return true;
    return false;
}
// Insert Cloudinary transformation params after /upload/ without double-inserting.
// Uses q_auto so Cloudinary picks optimal quality for each requested format.
function $b954784b1e5f57b8$var$cloudinaryOptimize(url, width) {
    if (!url || !$b954784b1e5f57b8$var$isCloudinaryUrl(url)) return url;
    if (url.includes('/upload/f_auto')) return url; // already optimized
    return url.replace('/upload/', `/upload/f_auto,q_auto,w_${width}/`);
}
function $b954784b1e5f57b8$var$escapeHtml(str) {
    return String(str ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}
// Escape the whole body first, then convert the admin-composer's
// `[text](https://…)` link syntax into real anchors. Because the conversion
// runs on already-escaped text, there is no way for a post body to inject
// arbitrary HTML — only this one exact, http(s)-only pattern becomes a tag.
function $b954784b1e5f57b8$var$renderBodyHtml(body) {
    const escaped = $b954784b1e5f57b8$var$escapeHtml(body);
    return escaped.replace(/\[([^[\]\n]{1,200})\]\((https?:\/\/[^\s)]+)\)/g, (_match, text, url)=>`<a href="${url}" target="_blank" rel="noopener noreferrer">${text}</a>`);
}
function $b954784b1e5f57b8$var$formatDate(iso) {
    return new Date(iso).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
}
function $b954784b1e5f57b8$var$getDisplayName(email) {
    if (!email) return 'Anonymous';
    return email.split('@')[0];
}
// ─── Image cache invalidation ─────────────────────────────────────────────────
/**
 * Evict a Cloudinary URL from the image cache after a post is deleted. Tries
 * the Cache API directly first; also notifies the SW for any variant entries
 * it may hold.
 *
 * @param {string} imageUrl
 */ async function $b954784b1e5f57b8$var$invalidateImageCache(imageUrl) {
    if (!imageUrl) return;
    try {
        if ('caches' in window) {
            const cache = await caches.open('sa-images-v1');
            await cache.delete(imageUrl);
        }
        if ('serviceWorker' in navigator && navigator.serviceWorker.controller) navigator.serviceWorker.controller.postMessage({
            type: 'INVALIDATE_IMAGE',
            url: imageUrl
        });
    } catch (err) {
        console.warn('[post-render] invalidateImageCache error:', err);
    }
}
function $b954784b1e5f57b8$export$823f4865e91cfbff(post, { pending: pending = false, fullView: fullView = false } = {}) {
    const article = document.createElement('article');
    article.className = 'post-card';
    if (pending) {
        article.dataset.pendingId = post.id;
        article.classList.add('post-card--pending');
    }
    if (post.title) {
        const h3 = document.createElement('h3');
        h3.className = 'post-title';
        h3.textContent = post.title;
        article.appendChild(h3);
    }
    // Media — image, video, or audio
    if ($b954784b1e5f57b8$var$isCloudinaryUrl(post.imageUrl)) {
        if ($b954784b1e5f57b8$var$isAudioUrl(post.imageUrl)) {
            const audio = document.createElement('audio');
            audio.className = 'post-audio';
            audio.controls = true;
            const source = document.createElement('source');
            source.src = post.imageUrl;
            audio.appendChild(source);
            article.appendChild(audio);
        } else if ($b954784b1e5f57b8$var$isCloudinaryVideo(post.imageUrl)) {
            const video = document.createElement('video');
            video.className = 'post-image';
            video.controls = true;
            video.preload = 'none'; // don't preload video data until user interacts
            video.setAttribute('playsinline', '');
            video.setAttribute('loading', 'lazy');
            const source = document.createElement('source');
            source.src = post.imageUrl;
            // Let the browser figure out the MIME type from the URL extension
            video.appendChild(source);
            article.appendChild(video);
        } else {
            const img = document.createElement('img');
            img.className = 'post-image';
            img.alt = post.title || '';
            img.loading = 'lazy';
            img.decoding = 'async';
            // Responsive srcset via Cloudinary on-the-fly transforms.
            // The feed container is capped at 700px; 1400w covers 2× retina.
            img.srcset = [
                `${$b954784b1e5f57b8$var$cloudinaryOptimize(post.imageUrl, 400)} 400w`,
                `${$b954784b1e5f57b8$var$cloudinaryOptimize(post.imageUrl, 700)} 700w`,
                `${$b954784b1e5f57b8$var$cloudinaryOptimize(post.imageUrl, 1400)} 1400w`
            ].join(', ');
            // Container is max 700px wide; below 736px it fills the viewport.
            img.sizes = '(max-width: 736px) 100vw, 700px';
            img.src = $b954784b1e5f57b8$var$cloudinaryOptimize(post.imageUrl, 700); // fallback
            img.style.cursor = 'zoom-in';
            img.addEventListener('click', ()=>{
                (0, $aSNdN.lightbox).open($b954784b1e5f57b8$var$cloudinaryOptimize(post.imageUrl, 1600), post.title || '');
            });
            article.appendChild(img);
        }
    }
    // Body — split on the author's Read More marker (if any) when not in full view
    const breakIdx = post.body.indexOf($b954784b1e5f57b8$var$READ_MORE_MARKER);
    const hasBreak = breakIdx !== -1;
    const p = document.createElement('p');
    p.className = 'post-body';
    if (hasBreak && !fullView) // renderBodyHtml() escapes the whole body first and only then converts
    // the composer's [text](url) syntax to anchors, so a post body cannot
    // introduce any other markup.
    // eslint-disable-next-line no-restricted-syntax
    p.innerHTML = $b954784b1e5f57b8$var$renderBodyHtml(post.body.slice(0, breakIdx).trimEnd());
    else // renderBodyHtml() escapes the whole body first and only then converts
    // the composer's [text](url) syntax to anchors, so a post body cannot
    // introduce any other markup.
    // eslint-disable-next-line no-restricted-syntax
    p.innerHTML = $b954784b1e5f57b8$var$renderBodyHtml(hasBreak ? post.body.split($b954784b1e5f57b8$var$READ_MORE_MARKER).join('').replace(/\n{3,}/g, '\n\n').trim() : post.body);
    article.appendChild(p);
    if (hasBreak && !fullView) {
        const readMore = document.createElement('a');
        readMore.className = 'read-more-link';
        readMore.href = `/post/${encodeURIComponent(post.id)}`;
        readMore.textContent = "Read more \u2192";
        article.appendChild(readMore);
    }
    // Footer: meta + optional delete button
    const footer = document.createElement('div');
    footer.className = 'post-footer';
    const meta = document.createElement('p');
    meta.className = 'post-meta';
    if (pending) {
        meta.textContent = "\u23F3 Pending sync\u2026";
        meta.classList.add('post-meta--pending');
    } else meta.textContent = $b954784b1e5f57b8$var$formatDate(post.createdAt);
    footer.appendChild(meta);
    // Delete button — only for published posts when a session is active
    if (!pending) {
        if ((0, $5IRmI.isLoggedIn)()) {
            const deleteBtn = document.createElement('button');
            deleteBtn.className = 'post-delete-btn';
            deleteBtn.textContent = "\u2715 Delete";
            deleteBtn.setAttribute('aria-label', 'Delete post');
            deleteBtn.addEventListener('click', async ()=>{
                if (!confirm('Are you sure you want to delete this post?')) return;
                deleteBtn.disabled = true;
                deleteBtn.textContent = "Deleting\u2026";
                try {
                    await (0, $36CJS.api).posts.remove(post.id);
                    // Evict the deleted post's image from the SW cache so it doesn't
                    // linger and consume quota.
                    if (post.imageUrl) await $b954784b1e5f57b8$var$invalidateImageCache(post.imageUrl);
                    article.remove();
                } catch (err) {
                    console.error('[post-render] Delete error:', err);
                    deleteBtn.disabled = false;
                    deleteBtn.textContent = "\u2715 Delete";
                    alert(`Failed to delete post: ${err.message}`);
                }
            });
            footer.appendChild(deleteBtn);
        }
    }
    article.appendChild(footer);
    // Like + comments — only for published posts
    if (!pending) {
        article.appendChild($b954784b1e5f57b8$var$buildPostActions(post));
        article.appendChild($b954784b1e5f57b8$var$buildCommentsSection(post));
    }
    return article;
}
// ─── Like + comments-toggle row ────────────────────────────────────────────────
/**
 * Render the heart and count into a like button.
 *
 * Built from nodes rather than an innerHTML template because likeCount comes
 * back from the server, and this was the only place in this file where a
 * server value was spliced into markup.
 *
 * @param {HTMLElement} button
 * @param {boolean} liked
 * @param {number} count
 */ function $b954784b1e5f57b8$var$paintLikeButton(button, liked, count) {
    button.replaceChildren();
    const heart = document.createElement('span');
    heart.className = 'like-heart';
    heart.textContent = liked ? '\u2665' : '\u2661';
    const total = document.createElement('span');
    total.className = 'like-count';
    total.textContent = String(count);
    button.append(heart, total);
}
function $b954784b1e5f57b8$var$buildPostActions(post) {
    const actions = document.createElement('div');
    actions.className = 'post-actions';
    const likeBtn = document.createElement('button');
    likeBtn.type = 'button';
    likeBtn.className = 'like-btn';
    const liked = $b954784b1e5f57b8$var$myLikedPostIds.has(post.id);
    if (liked) likeBtn.classList.add('liked');
    likeBtn.setAttribute('aria-label', liked ? 'Unlike this post' : 'Like this post');
    $b954784b1e5f57b8$var$paintLikeButton(likeBtn, liked, post.likeCount || 0);
    likeBtn.addEventListener('click', async ()=>{
        if (!(0, $5IRmI.isLoggedIn)()) {
            (0, $3qsiv.authModal).open('login');
            return;
        }
        likeBtn.disabled = true;
        try {
            const { liked: nowLiked, likeCount: likeCount } = await (0, $36CJS.api).posts.toggleLike(post.id);
            if (nowLiked) $b954784b1e5f57b8$var$myLikedPostIds.add(post.id);
            else $b954784b1e5f57b8$var$myLikedPostIds.delete(post.id);
            likeBtn.classList.toggle('liked', nowLiked);
            likeBtn.setAttribute('aria-label', nowLiked ? 'Unlike this post' : 'Like this post');
            $b954784b1e5f57b8$var$paintLikeButton(likeBtn, nowLiked, likeCount);
        } catch (err) {
            console.error('[post-render] like error:', err);
            alert(`Could not update like: ${err.message}`);
        } finally{
            likeBtn.disabled = false;
        }
    });
    const commentsToggleBtn = document.createElement('button');
    commentsToggleBtn.type = 'button';
    commentsToggleBtn.className = 'comments-toggle-btn';
    const commentCount = post.commentCount || 0;
    commentsToggleBtn.dataset.commentCount = commentCount;
    commentsToggleBtn.setAttribute('aria-expanded', 'false');
    commentsToggleBtn.textContent = commentCount === 0 ? "Comments (0) \u25B8" : `${commentCount} comment${commentCount === 1 ? '' : 's'} \u{25B8}`;
    actions.appendChild(likeBtn);
    actions.appendChild(commentsToggleBtn);
    // Wired up once the comments section (built alongside) exists in the DOM
    actions.dataset.postId = post.id;
    commentsToggleBtn.addEventListener('click', ()=>{
        const article = actions.closest('.post-card');
        const container = article?.querySelector('.comments-container');
        if (!container) return;
        const isOpen = container.classList.contains('visible');
        if (isOpen) {
            container.classList.remove('visible');
            commentsToggleBtn.setAttribute('aria-expanded', 'false');
        } else {
            container.classList.add('visible');
            commentsToggleBtn.setAttribute('aria-expanded', 'true');
            if (!container.dataset.loaded) {
                container.dataset.loaded = 'true';
                const listEl = container.querySelector('.comments-list');
                const noneEl = container.querySelector('.no-comments');
                const loadingEl = container.querySelector('.comments-loading');
                const formEl = container.querySelector('.comment-form-section');
                $b954784b1e5f57b8$var$loadComments(post.id, listEl, noneEl, loadingEl, commentsToggleBtn);
                $b954784b1e5f57b8$var$renderCommentFormSection(formEl, post.id, listEl, noneEl, commentsToggleBtn);
            }
        }
        const count = parseInt(commentsToggleBtn.dataset.commentCount || '0', 10);
        const arrow = container.classList.contains('visible') ? "\u25BE" : "\u25B8";
        commentsToggleBtn.textContent = count === 0 ? `Comments (0) ${arrow}` : `${count} comment${count === 1 ? '' : 's'} ${arrow}`;
    });
    return actions;
}
function $b954784b1e5f57b8$var$buildCommentsSection() {
    const container = document.createElement('div');
    container.className = 'comments-container';
    const loadingEl = document.createElement('p');
    loadingEl.className = 'comments-loading';
    loadingEl.textContent = "Loading comments\u2026";
    loadingEl.hidden = true;
    const noneEl = document.createElement('p');
    noneEl.className = 'no-comments';
    noneEl.textContent = "No comments yet \u2014 be the first!";
    noneEl.hidden = true;
    const listEl = document.createElement('div');
    listEl.className = 'comments-list';
    const formSection = document.createElement('div');
    formSection.className = 'comment-form-section';
    container.appendChild(loadingEl);
    container.appendChild(noneEl);
    container.appendChild(listEl);
    container.appendChild(formSection);
    return container;
}
// ─── Load + render comments ────────────────────────────────────────────────────
async function $b954784b1e5f57b8$var$loadComments(postId, listEl, noneEl, loadingEl, toggleBtn) {
    loadingEl.hidden = false;
    noneEl.hidden = true;
    listEl.innerHTML = '';
    try {
        const comments = await (0, $36CJS.api).posts.comments.list(postId);
        loadingEl.hidden = true;
        // Reconcile the toggle label with the authoritative fetched count
        if (toggleBtn) {
            toggleBtn.dataset.commentCount = comments.length;
            toggleBtn.textContent = comments.length === 0 ? "Comments (0) \u25BE" : `${comments.length} comment${comments.length === 1 ? '' : 's'} \u{25BE}`;
        }
        if (!comments.length) {
            noneEl.hidden = false;
            return;
        }
        comments.forEach((comment)=>listEl.appendChild($b954784b1e5f57b8$var$buildCommentCard(comment, postId, listEl, noneEl, toggleBtn)));
    } catch (err) {
        loadingEl.hidden = true;
        listEl.innerHTML = `<p class="comment-status error">Could not load comments.</p>`;
        console.error('[post-render] loadComments error:', err);
    }
}
function $b954784b1e5f57b8$var$buildCommentCard(comment, postId, listEl, noneEl, toggleBtn) {
    const card = document.createElement('div');
    card.className = 'comment-card';
    card.dataset.commentId = comment.id;
    const header = document.createElement('div');
    header.className = 'comment-header';
    const author = document.createElement('span');
    author.className = 'comment-author';
    author.textContent = $b954784b1e5f57b8$var$getDisplayName(comment.author);
    const date = document.createElement('span');
    date.className = 'comment-date';
    date.textContent = $b954784b1e5f57b8$var$formatDate(comment.createdAt);
    header.appendChild(author);
    header.appendChild(date);
    if ((0, $5IRmI.isLoggedIn)()) {
        const deleteBtn = document.createElement('button');
        deleteBtn.type = 'button';
        deleteBtn.className = 'comment-delete-btn';
        deleteBtn.textContent = 'Delete';
        deleteBtn.setAttribute('aria-label', 'Delete this comment');
        deleteBtn.addEventListener('click', ()=>$b954784b1e5f57b8$var$handleDeleteComment(postId, comment.id, card, listEl, noneEl, toggleBtn));
        header.appendChild(deleteBtn);
    }
    const body = document.createElement('p');
    body.className = 'comment-body';
    body.textContent = comment.body;
    card.appendChild(header);
    card.appendChild(body);
    return card;
}
async function $b954784b1e5f57b8$var$handleDeleteComment(postId, commentId, cardEl, listEl, noneEl, toggleBtn) {
    if (!confirm('Delete this comment?')) return;
    const btn = cardEl.querySelector('.comment-delete-btn');
    if (btn) {
        btn.disabled = true;
        btn.textContent = "Deleting\u2026";
    }
    try {
        await (0, $36CJS.api).posts.comments.remove(postId, commentId);
        cardEl.remove();
        if (toggleBtn) {
            const count = Math.max(0, parseInt(toggleBtn.dataset.commentCount || '1', 10) - 1);
            toggleBtn.dataset.commentCount = count;
            const arrow = toggleBtn.getAttribute('aria-expanded') === 'true' ? "\u25BE" : "\u25B8";
            toggleBtn.textContent = count === 0 ? `Comments (0) ${arrow}` : `${count} comment${count === 1 ? '' : 's'} ${arrow}`;
        }
        if (listEl && noneEl && !listEl.children.length) noneEl.hidden = false;
    } catch (err) {
        console.error('[post-render] delete comment error:', err);
        alert(`Could not delete comment: ${err.message}`);
        if (btn) {
            btn.disabled = false;
            btn.textContent = 'Delete';
        }
    }
}
// ─── Comment form (auth-aware) ─────────────────────────────────────────────────
function $b954784b1e5f57b8$var$renderCommentFormSection(container, postId, listEl, noneEl, toggleBtn) {
    if (container.dataset.built) return;
    container.dataset.built = 'true';
    if (!(0, $5IRmI.isLoggedIn)()) {
        const authMsg = document.createElement('div');
        authMsg.className = 'comment-auth-required';
        authMsg.innerHTML = `Sign in to leave a comment &nbsp;
      <button type="button" class="btn btn-sm" style="margin-inline-start:0.5em;">Sign In</button>`;
        authMsg.querySelector('button').addEventListener('click', ()=>(0, $3qsiv.authModal).open('login'));
        container.appendChild(authMsg);
        return;
    }
    const form = document.createElement('form');
    form.className = 'comment-form';
    const textarea = document.createElement('textarea');
    textarea.placeholder = "Write a comment\u2026";
    textarea.required = true;
    const submitBtn = document.createElement('button');
    submitBtn.type = 'submit';
    submitBtn.className = 'btn btn-sm';
    submitBtn.textContent = 'Post Comment';
    const status = document.createElement('p');
    status.className = 'comment-status';
    form.appendChild(textarea);
    form.appendChild(submitBtn);
    form.appendChild(status);
    container.appendChild(form);
    form.addEventListener('submit', async (e)=>{
        e.preventDefault();
        const body = textarea.value.trim();
        if (!body) return;
        submitBtn.disabled = true;
        submitBtn.textContent = "Posting\u2026";
        status.textContent = '';
        status.className = 'comment-status';
        try {
            const comment = await (0, $36CJS.api).posts.comments.create(postId, body);
            if (noneEl) noneEl.hidden = true;
            listEl?.appendChild($b954784b1e5f57b8$var$buildCommentCard(comment, postId, listEl, noneEl, toggleBtn));
            if (toggleBtn) {
                const count = parseInt(toggleBtn.dataset.commentCount || '0', 10) + 1;
                toggleBtn.dataset.commentCount = count;
                toggleBtn.textContent = `${count} comment${count === 1 ? '' : 's'} \u{25BE}`;
            }
            textarea.value = '';
            status.textContent = 'Comment posted!';
            status.className = 'comment-status success';
            setTimeout(()=>{
                status.textContent = '';
            }, 3000);
        } catch (err) {
            console.error('[post-render] post comment error:', err);
            status.textContent = `Error: ${err.message}`;
            status.className = 'comment-status error';
        } finally{
            submitBtn.disabled = false;
            submitBtn.textContent = 'Post Comment';
        }
    });
}
async function $b954784b1e5f57b8$export$1976b3a42df716d9() {
    if (!(0, $5IRmI.isLoggedIn)()) return;
    try {
        const { postIds: postIds } = await (0, $36CJS.api).me.likes();
        $b954784b1e5f57b8$var$myLikedPostIds = new Set(postIds || []);
    } catch (err) {
        console.warn('[post-render] loadMyLikes error:', err);
    }
}

});


//# sourceMappingURL=feed.483da9e4.js.map
